const MINUTE_IN_SEC = 60;
const HOUR_IN_SEC = 3600;
const DAY_IN_SEC = 86400;
const MONTH_IN_SEC = 2592000;
const YEAR_IN_SEC = 31536000;
/**
 * use Intl.DateTimeFormat to format a date in the requested locale
 * @param date the date to formate
 * @param param1 options to apply to the date format
 * @returns a string representing the date
 */
export function localisedDate(date, { languageId, dateFormat = 'long', withTime = true, }) {
    return new Intl.DateTimeFormat(languageId, {
        dateStyle: dateFormat,
        timeStyle: withTime ? 'short' : undefined,
    }).format(date);
}
/**
 * use Intl.RelativeTimeFormat to format a time ago
 * @param dateCompareTo probably will be something like Date.now
 * @param dateCompareFrom this is that date you want to compare against
 * @param languageId short locale string, like en_US, zh etc
 * @returns the formatted date
 */
export function localisedTimeAgo(dateCompareTo, dateCompareFrom, languageId) {
    const secondsAgo = (dateCompareFrom - dateCompareTo) / 1000;
    // try, catch just incase Intl isn't defined
    try {
        const rtf = new Intl.RelativeTimeFormat(languageId, {
            localeMatcher: 'best fit',
            numeric: 'auto',
            style: 'long', // other values: "short" or "narrow"
        });
        const absSecs = Math.abs(secondsAgo);
        if (absSecs < MINUTE_IN_SEC) {
            return rtf.format(Math.round(secondsAgo), 'second');
        }
        else if (absSecs < HOUR_IN_SEC) {
            return rtf.format(Math.round(secondsAgo / MINUTE_IN_SEC), 'minute');
        }
        else if (absSecs < DAY_IN_SEC) {
            return rtf.format(Math.round(secondsAgo / HOUR_IN_SEC), 'hour');
        }
        else if (absSecs < MONTH_IN_SEC) {
            return rtf.format(Math.round(secondsAgo / DAY_IN_SEC), 'day');
        }
        else if (absSecs < YEAR_IN_SEC) {
            return rtf.format(Math.round(secondsAgo / MONTH_IN_SEC), 'month');
        }
        return rtf.format(Math.round(secondsAgo / YEAR_IN_SEC), 'year');
    }
    catch (error) {
        // Ignore errors, probably from IE
    }
    return '';
}
//# sourceMappingURL=format.js.map